export default function multiviewUrlIdxNameToNumber(idx) {
  if (Number.isFinite(idx)) return idx;

  switch (idx) {
    case 'main_camera':
      return 3;

    case 'wide_camera':
      return 4;

    case 'slides':
      return 5;

    case 'input_4':
      return 6;

    case 'multiview':
      return 220;
  }

  return 220;
}
